/**
 * HEVI.HU – 3-stupňový darčekový progress bar v košíku (drawer + /cart)
 * ------------------------------------------------------------------------
 * Náhrada Rebuy Smart Cart tiered progress baru zo SK – tu čisto v kóde témy.
 *   1. doprava zdarma   (GLS: 0–12 900 Ft = 1 495 Ft, od 12 901 Ft zdarma)
 *   2. 2 db Melatonin Gummies vzorka zdarma   (od 28 950 Ft)
 *   3. Hevi™ Calma súlyozott alvómaszk zdarma (od 47 950 Ft)
 *
 * Čo robí:
 *   - vykreslí bar navrch cart drawera aj stránky /cart (nahrádza free-shipping bar z hu-cart-variant-b.js)
 *   - darček (tier s variantId) pridá 1 ks, keď sa dosiahne hranica, a odoberie, keď suma klesne pod ňu
 *   - anti-abuse: darček vždy max 1 ks; darček v košíku bez dosiahnutej hranice (pridaný cez URL / /cart/add.js)
 *     sa odstráni – beží pri načítaní každej stránky, po každom prekreslení košíka a po každom /cart/* requeste
 *   - darčekové riadky: bez +/- a bez "Eltávolítás", namiesto toho štítok "Ajándék", cena 0 Ft + prečiarknutá hodnota
 *
 * Suma pre hranice = cart.total_price (po zľavách) MÍNUS riadky darčekov (tie sú 0 Ft).
 * Idempotentné – dá sa spustiť opakovane; mutácie košíka majú zámok (nikdy 2 dávky naraz) a strop na stránku.
 * Gift produkty na PDP (skrytie tlačidla) rieši snippets/hu-gift-product.liquid – zoznam handle drž v súlade s TIERS nižšie.
 */
(function () {
  'use strict';

  /* =====================================================================
   * ===================  KONFIGURÁCIA – MEŇ LEN TU  ======================
   * =====================================================================
   * Sumy sú v celých Ft. Tier je splnený, keď suma košíka (bez darčekov) >= minFt.
   * variantId: null  = tier sa zobrazuje a počíta, ale darček sa automaticky NEpridáva.
   * handle          = darčekový produkt (riadky s týmto handle / variantId sú "darčeky" → max 1 ks, inak preč).
   * active: false   = tier sa nezobrazí ani nepočíta a jeho darčekové riadky sa z košíka vždy odstránia.
   * {amount}        = v texte sa nahradí chýbajúcou sumou (napr. "3 450 Ft"), {value} = hodnotou darčeka (valueFt).
   */
  var HGP_CONFIG = {
    TIERS: [
      {
        id: 'shipping',
        type: 'shipping',
        active: true,
        minFt: 12901,                               // GLS: do 12 900 Ft = 1 495 Ft, od 12 901 Ft zdarma
        icon: 'truck',
        label: 'Ingyenes szállítás',
        msgMissing: 'Már csak {amount}, és ingyenes a szállítás!'
      },
      {
        id: 'gummies',
        type: 'gift',
        active: true,
        minFt: 28950,
        icon: 'gift',
        label: 'Ajándék Gummies',
        labelShort: 'Ajándék Gummies',                 // kratší názov v popup košíku (kompaktný bar)
        variantId: 67887858417766,                  // produkt "melatonin-gummies-ajandek-minta" (0 Ft, unlisted), vytvorený 1.11.2026
        handle: 'melatonin-gummies-ajandek-minta',  // plánovaný handle darčekového produktu (ak bude iný, prepíš aj v snippets/hu-gift-product.liquid)
        valueFt: null,                              // hodnota na prečiarknutie v košíku (null = nezobrazovať)
        lineTitle: null,                            // názov riadku v košíku (null = názov produktu)
        msgMissing: 'Már csak {amount}, és ajándékba kap 2 db Melatonin Gummies gumicukrot!'
      },
      {
        id: 'calma',
        type: 'gift',
        active: true,
        minFt: 47950,
        icon: 'gift',
        label: 'Ajándék Calma',
        variantId: 45444785995878,                  // produkt "ingyenes-calma" (0 Ft, unlisted)
        handle: 'ingyenes-calma',
        valueFt: 14270,
        lineTitle: null,                            // produkt je už v admine premenovaný na HU názov (1.11.2026)
        msgMissing: 'Már csak {amount}, és ajándékba kapja a {value} értékű Calma alvómaszkot!'
      }
    ],
    TEXT: {
      strip: 'Szállítás 1–2 munkanapon belül',
      allUnlocked: 'Gratulálunk! Ingyenes a szállítás, és mindkét ajándék a kosárba került.',
      giftBadge: 'Ajándék',
      currencySuffix: ' Ft'
    },
    COLORS: {                                       // z config/settings_data.json témy
      navy: '#170381',                              // color_text_main
      lime: '#c7d259',                              // cart_mini_background (HEVI lime)
      strip: '#f2f2f2',                             // color_background_main_secondary
      track: '#e6e6ec',
      off: '#ebebf0'
    },
    GIFT_PROPERTY: '_hevi_gift',                    // skrytá vlastnosť riadku (podčiarkovník = nezobrazí sa v košíku ani v checkoute)
    RATE_MAX_OPS: 10,                               // poistka proti slučke: max. 10 úprav/prekreslení košíka …
    RATE_WINDOW_MS: 20000,                          // … za 20 s, potom pauza do konca okna
    CHECKOUT_GUARD: true,                           // pred odchodom do pokladne ešte raz overiť/vyčistiť darčeky (max. 3 s, potom pokračuje vždy)
    DEBUG: false
  };
  /* ======================= KONIEC KONFIGURÁCIE ======================= */

  if (window.__hgpLoaded) return;
  window.__hgpLoaded = true;

  var CFG = HGP_CONFIG;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TIERS = CFG.TIERS.filter(function (t) { return t.active !== false; });
  var GIFT_TIERS_ALL = CFG.TIERS.filter(function (t) { return t.type === 'gift'; });

  function log() { if (CFG.DEBUG && window.console) console.log.apply(console, ['[hgp]'].concat([].slice.call(arguments))); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // formát ako obchod: {{ amount_no_decimals_with_space_separator }} Ft  (nedeliteľné medzery, aby sa suma nelámala)
  function money(ft) { return String(Math.round(ft)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + CFG.TEXT.currencySuffix.replace(/ /g, ' '); }

  /* ======================= IKONY ======================= */
  var SVG = {
    check: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10.5 3 12 8 12 8s1.5-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 5h12v11H2z"/><path d="M14 9h4l4 4v3h-8z"/><circle cx="6.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></svg>'
  };

  /* ======================= CSS ======================= */
  var C = CFG.COLORS;
  var CSS = '' +
    '.hgp{--hgp-navy:' + C.navy + ';--hgp-lime:' + C.lime + ';--hgp-strip:' + C.strip + ';--hgp-track:' + C.track + ';--hgp-off:' + C.off + ';color:var(--hgp-navy);font-size:13px;line-height:1.3;box-sizing:border-box;width:100%;max-width:100%}' +
    '.hgp *{box-sizing:border-box}' +
    '.hgp[hidden]{display:none!important}' +
    '.hgp svg *{fill:none!important}' +
    '.hgp__strip{background:var(--hgp-strip);display:flex;align-items:center;justify-content:center;gap:8px;padding:9px 12px;font-weight:700;text-align:center}' +
    '.hgp__strip svg{width:18px;height:18px;flex:0 0 18px;stroke:var(--hgp-navy)}' +
    '.hgp__body{padding:14px 0 12px}' +
    '.hgp__steps{display:grid;grid-template-columns:repeat(var(--hgp-n,3),minmax(0,1fr));gap:4px;margin:0 0 10px;padding:0;list-style:none}' +
    '.hgp__step{display:flex;flex-direction:column;align-items:center;text-align:center;gap:6px;min-width:0;margin:0}' +
    '.hgp__icon{width:34px;height:34px;border-radius:50%;background:var(--hgp-off);display:flex;align-items:center;justify-content:center;color:var(--hgp-navy);transition:background-color .3s}' +
    '.hgp__icon svg{width:18px;height:18px;opacity:.55;stroke:var(--hgp-navy)}' +
    '.hgp__step.is-done .hgp__icon{background:var(--hgp-lime)}' +
    '.hgp__step.is-done .hgp__icon svg{opacity:1;width:17px;height:17px}' +
    '.hgp__label{font-size:12px;font-weight:600;line-height:1.25;overflow-wrap:anywhere;opacity:.65}' +
    '.hgp__step.is-done .hgp__label{opacity:1}' +
    '.hgp__track{position:relative;height:8px;border-radius:8px;background:var(--hgp-track);overflow:hidden}' +
    '.hgp__fill{position:absolute;left:0;top:0;bottom:0;width:0;background:var(--hgp-lime);border-radius:8px;transition:width .45s ease}' +
    '.hgp__msg{margin:10px 0 0;text-align:center;font-size:13px;font-weight:600;color:var(--hgp-navy);line-height:1.35}' +
    '.hgp__msg b{font-weight:800;white-space:nowrap}' +
    /* drawer: bar je prvé dieťa .sidebar__body, pás cez celú šírku */
    '#site-cart-sidebar .sidebar__body>.hgp{padding:0!important;border-top:0!important}' +
    '#site-cart-sidebar .hgp__body{padding:14px var(--sidebar-gutter,20px) 12px}' +
    /* kompaktná verzia v popup košíku (drawer) – menšie ikony, tenší pás, kratšie názvy */
    '.hgp--compact{font-size:12px}' +
    '.hgp--compact .hgp__strip{padding:5px 10px;gap:6px;font-size:12px}' +
    '.hgp--compact .hgp__strip svg{width:15px;height:15px;flex-basis:15px}' +
    '#site-cart-sidebar .hgp--compact .hgp__body{padding:8px var(--sidebar-gutter,20px) 8px}' +
    '.hgp--compact .hgp__steps{margin:0 0 6px;gap:2px}' +
    '.hgp--compact .hgp__step{gap:3px}' +
    '.hgp--compact .hgp__icon{width:22px;height:22px;flex:0 0 22px}' +
    '.hgp--compact .hgp__icon svg,.hgp--compact .hgp__step.is-done .hgp__icon svg{width:12px;height:12px}' +
    '.hgp--compact .hgp__label{font-size:11px;line-height:1.15;overflow-wrap:normal;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}' +
    '.hgp--compact .hgp__track{height:6px}' +
    '.hgp--compact .hgp__msg{margin:6px 0 0;font-size:12px;line-height:1.3}' +
    /* /cart: box nad položkami */
    '.hgp--page{border:1px solid var(--color-borders-main,#e5e5e5);border-radius:var(--border-radius-widgets,8px);overflow:hidden;margin:0 0 var(--gutter-regular,20px)}' +
    '.hgp--page .hgp__body{padding:16px 18px 14px}' +
    /* darčekové riadky v košíku */
    '.hgp-gift-line .quantity-selector-holder,.hgp-gift-line .cart-item__actions .remove{display:none!important}' +
    '.hgp-gift-badge{display:inline-flex;align-items:center;gap:6px;background:' + C.lime + ';color:' + C.navy + ';font-weight:700;font-size:12px;line-height:1;border-radius:999px;padding:6px 10px;white-space:nowrap}' +
    '.hgp-gift-badge svg{width:14px;height:14px;stroke:' + C.navy + '}' +
    '.hgp-gift-badge svg *{fill:none!important}' +
    '.hgp-was{opacity:.55;font-weight:400;margin-left:4px;white-space:nowrap}';

  function injectCSS() {
    if (document.getElementById('hgp-css')) return;
    var s = document.createElement('style'); s.id = 'hgp-css'; s.textContent = CSS; document.head.appendChild(s);
  }

  /* ======================= LOGIKA TIEROV ======================= */
  // Zoznam darčekových produktov z témy (snippets/hu-gift-product.liquid → <script id="hgp-gift-handles">).
  // Produkt zo zoznamu, ktorý nepatrí žiadnemu tieru, sa nedá mať v košíku vôbec (BLOCKED → vždy odstrániť).
  var BLOCKED = { id: '_blocked', type: 'gift', active: false };
  var listedHandles = null;
  function listed(handle) {
    if (!listedHandles) {
      listedHandles = [];
      try { var j = document.getElementById('hgp-gift-handles'); if (j) listedHandles = JSON.parse(j.textContent) || []; } catch (e) {}
    }
    return !!handle && listedHandles.indexOf(handle) !== -1;
  }
  function giftTierForItem(item) {
    for (var i = 0; i < GIFT_TIERS_ALL.length; i++) {
      var t = GIFT_TIERS_ALL[i];
      if ((t.variantId && String(item.variant_id) === String(t.variantId)) || (t.handle && item.handle === t.handle)) return t;
    }
    return listed(item.handle) ? BLOCKED : null;
  }
  function giftTierForHandle(handle) {
    for (var i = 0; i < GIFT_TIERS_ALL.length; i++) if (GIFT_TIERS_ALL[i].handle && GIFT_TIERS_ALL[i].handle === handle) return GIFT_TIERS_ALL[i];
    return listed(handle) ? BLOCKED : null;
  }
  // suma pre hranice v Ft: total_price po zľavách bez darčekových riadkov
  function basisFt(cart) {
    var s = cart.total_price || 0;
    (cart.items || []).forEach(function (it) { if (giftTierForItem(it)) s -= (it.final_line_price || 0); });
    return Math.max(0, s) / 100;
  }
  function isReached(t, ft) { return t.active !== false && ft >= t.minFt; }

  function fillPct(ft) {
    var n = TIERS.length;
    if (!n) return 0;
    if (ft >= TIERS[n - 1].minFt) return 100;
    for (var k = 0; k < n; k++) {
      if (ft < TIERS[k].minFt) {
        var prevT = k === 0 ? 0 : TIERS[k - 1].minFt;
        var prevPos = k === 0 ? 0 : (2 * (k - 1) + 1) / (2 * n);
        var pos = (2 * k + 1) / (2 * n);                       // stred stĺpca s ikonou
        var frac = Math.max(0, Math.min(1, (ft - prevT) / (TIERS[k].minFt - prevT)));
        return Math.round((prevPos + frac * (pos - prevPos)) * 1000) / 10;
      }
    }
    return 100;
  }

  function message(ft) {
    for (var i = 0; i < TIERS.length; i++) {
      if (ft < TIERS[i].minFt) {
        var t = TIERS[i];
        var txt = String(t.msgMissing);
        if (t.valueFt) txt = txt.split('{value}').join(money(t.valueFt));
        return txt.split('{amount}').map(esc).join('<b>' + money(t.minFt - ft) + '</b>');
      }
    }
    return esc(CFG.TEXT.allUnlocked);
  }

  /* ======================= RENDER BARU ======================= */
  function buildBar(extraClass, compact) {
    var bar = document.createElement('div');
    bar.className = 'hgp' + (extraClass ? ' ' + extraClass : '');
    bar.setAttribute('data-hgp', '');
    var steps = TIERS.map(function (t) {
      var lbl = (compact && t.labelShort) ? t.labelShort : t.label;
      return '<li class="hgp__step" data-hgp-tier="' + esc(t.id) + '"><span class="hgp__icon" data-hgp-icon></span><span class="hgp__label" title="' + esc(t.label) + '">' + esc(lbl) + '</span></li>';
    }).join('');
    bar.innerHTML =
      '<div class="hgp__strip">' + SVG.truck + '<span>' + esc(CFG.TEXT.strip) + '</span></div>' +
      '<div class="hgp__body">' +
        '<ul class="hgp__steps" style="--hgp-n:' + TIERS.length + '">' + steps + '</ul>' +
        '<div class="hgp__track" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span class="hgp__fill" data-hgp-fill></span></div>' +
        '<p class="hgp__msg" data-hgp-msg aria-live="polite"></p>' +
      '</div>';
    return bar;
  }

  function updateBar(bar, ft, itemCount) {
    bar.hidden = !itemCount;
    TIERS.forEach(function (t) {
      var step = bar.querySelector('[data-hgp-tier="' + t.id + '"]');
      if (!step) return;
      var done = isReached(t, ft);
      var want = done ? 'check' : t.icon;
      step.classList.toggle('is-done', done);
      var ic = step.querySelector('[data-hgp-icon]');
      if (ic && ic.getAttribute('data-icon') !== want) { ic.innerHTML = SVG[want] || SVG.gift; ic.setAttribute('data-icon', want); }
    });
    var pct = fillPct(ft);
    var fill = bar.querySelector('[data-hgp-fill]');
    if (fill) fill.style.width = pct + '%';
    var tr = bar.querySelector('.hgp__track');
    if (tr) tr.setAttribute('aria-valuenow', String(Math.round(pct)));
    var msg = bar.querySelector('[data-hgp-msg]');
    var html = message(ft);
    if (msg && msg.innerHTML !== html) msg.innerHTML = html;
  }

  function hosts() {
    var list = [];
    // cart drawer – prvé dieťa .sidebar__body (mimo #AjaxCartForm, ktorý téma prepisuje)
    var body = document.querySelector('#site-cart-sidebar .sidebar__body');
    if (body) {
      var b = body.querySelector(':scope > .hgp');
      if (!b) { b = buildBar('hide-if-empty-cart hgp--compact', true); body.insertBefore(b, body.firstChild); }
      list.push(b);
    }
    // stránka /cart – nad blok s položkami
    if (document.body.classList.contains('template-cart')) {
      var form = document.getElementById('AjaxCartForm');
      var wrap = form && form.parentElement;
      if (wrap && wrap.parentElement) {
        var p = wrap.parentElement.querySelector(':scope > .hgp');
        if (!p) { p = buildBar('hgp--page'); wrap.parentElement.insertBefore(p, wrap); }
        list.push(p);
      }
    }
    return list;
  }

  function renderBars(ft, itemCount) {
    if (!TIERS.length) return;
    hosts().forEach(function (b) { updateBar(b, ft, itemCount); });
  }

  // rýchly render bez siete – z DOM témy (#AjaxCartForm [data-cart-total] / [data-cart-count])
  function renderFromDom() {
    var form = document.getElementById('AjaxCartForm');
    if (!form) return;
    var tEl = form.querySelector('[data-cart-total]'), cEl = form.querySelector('[data-cart-count]');
    if (!tEl || !cEl) return;
    var ft = parseInt(String(tEl.textContent).replace(/[^\d]/g, ''), 10) || 0;   // darčeky sú 0 Ft → total sedí
    renderBars(ft, parseInt(cEl.textContent, 10) || 0);
  }

  /* ======================= DARČEKOVÉ RIADKY V KOŠÍKU ======================= */
  function handleFromRow(row) {
    var a = row.querySelector('a.cart-item__title, a.cart-item__thumbnail');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function decorate(cart) {
    var byKey = {};
    if (cart && cart.items) cart.items.forEach(function (it) { byKey[it.key] = it; });
    document.querySelectorAll('#AjaxCartForm [data-js-cart-item]').forEach(function (row) {
      var item = byKey[row.getAttribute('data-id')];
      var t = item ? giftTierForItem(item) : giftTierForHandle(handleFromRow(row));
      if (!t) { row.classList.remove('hgp-gift-line'); return; }
      row.classList.add('hgp-gift-line');
      var actions = row.querySelector('.cart-item__actions');
      if (actions && !actions.querySelector('.hgp-gift-badge')) {
        actions.insertAdjacentHTML('afterbegin', '<span class="hgp-gift-badge">' + SVG.gift + esc(CFG.TEXT.giftBadge) + '</span>');
      }
      if (t.lineTitle) {
        row.querySelectorAll('.cart-item__title > span').forEach(function (s) { if (s.textContent !== t.lineTitle) s.textContent = t.lineTitle; });
      }
      if (t.valueFt) {
        row.querySelectorAll('.cart-item__price > strong, .cart-item__price .element--hide-on-desk > strong, .cart-item__price .element--hide-on-small > span:not(.visually-hidden), .cart-item__total > strong').forEach(function (p) {
          // už pridané, alebo téma má vlastné <del> (compare-at) → nedávaj druhé
          if (p.parentElement.querySelector('del')) return;
          p.insertAdjacentHTML('afterend', ' <del class="hgp-was">' + money(t.valueFt) + '</del>');
        });
      }
    });
  }

  /* ======================= SIEŤ ======================= */
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  }
  function postJSON(path, body) {
    return fetch(ROOT + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status === 422 || j.status === 404) { var e = new Error(j.description || j.message || ('HTTP ' + r.status)); e.status = r.status; throw e; } return j; }); });
  }

  /* ======================= PLÁN ÚPRAV ======================= */
  function plan(cart) {
    var ft = basisFt(cart);
    var updates = {}, adds = [], nUpd = 0;
    GIFT_TIERS_ALL.concat([BLOCKED]).forEach(function (t) {
      var lines = (cart.items || []).filter(function (it) { return giftTierForItem(it) === t; });
      if (!isReached(t, ft)) {                                   // hranica nesplnená (alebo tier vypnutý) → všetky riadky preč
        lines.forEach(function (l) { updates[l.key] = 0; nUpd++; });
        return;
      }
      if (!lines.length) {                                       // splnená a darček chýba → pridať 1 ks (len ak poznáme variant)
        if (t.variantId && !state.failed[t.variantId]) adds.push(t);
        return;
      }
      // splnená → nechaj presne 1 riadok s 1 ks (prednostne ten s našou vlastnosťou), ostatné preč
      lines.sort(function (a, b) { return hasProp(b) - hasProp(a); });
      lines.forEach(function (l, i) { var want = i === 0 ? 1 : 0; if (l.quantity !== want) { updates[l.key] = want; nUpd++; } });
    });
    return { ft: ft, updates: nUpd ? updates : null, adds: adds };
  }
  function hasProp(l) { return l.properties && l.properties[CFG.GIFT_PROPERTY] ? 1 : 0; }

  /* ======================= PREKRESLENIE KOŠÍKA (ako téma) ======================= */
  // rovnaký postup ako téma (component-cart.js updateCartQty / window.refreshCart), ale bez otvárania drawera
  function rerender() {
    return fetch('?section_id=helper-cart', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var nf = doc.getElementById('AjaxCartForm'), ns = doc.getElementById('AjaxCartSubtotal');
        var form = document.getElementById('AjaxCartForm'), sub = document.getElementById('AjaxCartSubtotal');
        if (!nf || !form) throw new Error('no AjaxCartForm');
        form.innerHTML = nf.innerHTML;
        if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
        var cnt = form.querySelector('[data-cart-count]'), tot = form.querySelector('[data-cart-total]');
        if (cnt) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = cnt.textContent; });
        if (tot) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = tot.textContent; });
        if (ns && sub) sub.innerHTML = ns.innerHTML;
        form.dispatchEvent(new Event('cart-updated'));            // variant B + prázdny košík na /cart sa re-aplikujú
      })
      .catch(function (e) {
        log('rerender failed', e);
        if (document.body.classList.contains('template-cart') && canReload()) location.reload();
      });
  }
  function canReload() {
    try {
      var k = 'hgp_reloads', now = Date.now();
      var arr = JSON.parse(sessionStorage.getItem(k) || '[]').filter(function (t) { return now - t < 30000; });
      if (arr.length >= 2) return false;
      arr.push(now); sessionStorage.setItem(k, JSON.stringify(arr)); return true;
    } catch (e) { return false; }
  }

  // DOM zodpovedá košíku? (kľúče + množstvá riadkov) – ak nie, prekresliť (napr. téma dostala starší render)
  function domMatches(cart) {
    var form = document.getElementById('AjaxCartForm');
    if (!form) return true;
    var rows = form.querySelectorAll('[data-js-cart-item]');
    var items = cart.items || [];
    if (rows.length !== items.length) return false;
    var want = {};
    items.forEach(function (it) { want[it.key] = it.quantity; });
    for (var i = 0; i < rows.length; i++) {
      var k = rows[i].getAttribute('data-id');
      if (!(k in want) || String(want[k]) !== String(rows[i].getAttribute('data-qty'))) return false;
    }
    return true;
  }

  function setProcessing(on) {
    document.querySelectorAll('#AjaxCartForm .cart__form').forEach(function (f) { f.classList.toggle('processing', on); });
  }

  /* ======================= HLAVNÝ CYKLUS (so zámkom) ======================= */
  var state = { busy: false, pending: false, opTimes: [], failed: {}, lastOwnAt: 0, timer: null, retry: null, warned: false, forcedSig: null };

  // klzavé okno: max RATE_MAX_OPS úprav za RATE_WINDOW_MS; pri prekročení nič nerobí a skúsi to po uplynutí okna
  function spend() {
    var now = Date.now();
    state.opTimes = state.opTimes.filter(function (t) { return now - t < CFG.RATE_WINDOW_MS; });
    if (state.opTimes.length >= CFG.RATE_MAX_OPS) {
      if (!state.warned && window.console) { state.warned = true; console.warn('[hgp] príliš veľa úprav košíka za krátky čas – pauza'); }
      clearTimeout(state.retry);
      state.retry = setTimeout(sync, CFG.RATE_WINDOW_MS);
      return false;
    }
    state.opTimes.push(now);
    return true;
  }
  function sig(cart) { return (cart.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join('|'); }

  // force === true (len poistka pred pokladňou): úprava darčekov ide aj počas pauzy rate-limitu – je to 1 jednorazová kontrola, slučku nespôsobí
  function sync(force) {
    if (state.busy) { state.pending = true; return Promise.resolve(); }
    state.busy = true;
    var mutated = false;
    return getCart()
      .then(function (cart) {
        var p = plan(cart);
        log('plan', p.ft, p.updates, p.adds.map(function (t) { return t.id; }));
        if (!p.updates && !p.adds.length) return cart;
        if (force !== true && !spend()) return cart;
        setProcessing(true);
        var chain = Promise.resolve(cart);
        if (p.updates) {
          chain = chain.then(function () { mutated = true; return postJSON('cart/update.js', { updates: p.updates }); });
        }
        p.adds.forEach(function (t) {
          chain = chain.then(function () {
            mutated = true;
            var props = {}; props[CFG.GIFT_PROPERTY] = t.id;
            return postJSON('cart/add.js', { items: [{ id: Number(t.variantId), quantity: 1, properties: props }] })
              .catch(function (e) { state.failed[t.variantId] = true; log('add failed', t.id, e && e.message); });
          });
        });
        // po každej dávke znova načítať košík (overenie výsledku)
        return chain.catch(function (e) { log('update failed', e && e.message); }).then(getCart);
      })
      .then(function (cart) {
        // prekresliť po vlastnej úprave, alebo keď DOM nesedí s košíkom (max. 1× pre ten istý stav košíka)
        var s = sig(cart);
        var needRender = mutated || (!domMatches(cart) && state.forcedSig !== s);
        if (needRender && !mutated) state.forcedSig = s;
        // po vlastnej úprave prekresliť VŽDY (inak ostane v DOM starý košík so zlými číslami riadkov → +/- by menilo iný riadok);
        // rate-limit platí len pre úpravy košíka a pre prekreslenie bez vlastnej úpravy
        var after = needRender && (mutated || spend()) ? rerender() : Promise.resolve();
        return after.then(function () {
          state.lastCart = cart;
          state.lastOwnAt = Date.now();
          setProcessing(false);
          renderBars(basisFt(cart), cart.item_count || 0);
          decorate(cart);
        });
      })
      .catch(function (e) { log('sync failed', e && e.message); setProcessing(false); })
      .then(function () {
        state.busy = false;
        if (state.pending) { state.pending = false; schedule(60); }
      });
  }

  function schedule(ms) {
    clearTimeout(state.timer);
    state.timer = setTimeout(sync, ms == null ? 120 : ms);
  }

  /* ======================= POISTKA PRED POKLADŇOU ======================= */
  // Klik na "Tovább a pénztárhoz": počká na dobehnutie sync (napr. darček pridaný cez URL tesne pred klikom),
  // potom odošle formulár rovnako ako téma. Ak čokoľvek zlyhá alebo trvá > 3 s, pokračuje normálne.
  function waitIdle(maxMs) {
    var t0 = Date.now();
    return new Promise(function (res) {
      (function tick() { if (!state.busy || Date.now() - t0 > maxMs) res(); else setTimeout(tick, 50); })();
    });
  }
  function guardCheckout() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
      if (!btn || btn.getAttribute('data-hgp-pass') === '1') return;
      if (!btn.form) return;
      var formId = btn.form.id;
      e.preventDefault();
      var done = false;
      var go = function () {
        if (done) return; done = true;
        // po prekreslení košíka sú form aj tlačidlo nové elementy → vždy hľadať aktuálne v DOM
        var f = (formId && document.getElementById(formId)) || (btn.isConnected ? btn.form : null);
        // formulár nesie updates[] z DOM – ak DOM nesedí s košíkom (prekreslenie zlyhalo), ísť rovno do pokladne bez neho
        if (f && state.lastCart && !domMatches(state.lastCart)) f = null;
        var b = null;
        if (f) document.querySelectorAll('button[name="checkout"]').forEach(function (x) { if (!b && x.form === f) b = x; });
        try {
          if (f && b && typeof f.requestSubmit === 'function') {
            b.setAttribute('data-hgp-pass', '1'); f.requestSubmit(b);
            setTimeout(function () { b.removeAttribute('data-hgp-pass'); }, 0);   // po návrate (bfcache) musí poistka znova fungovať
            return;
          }
          if (f) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '1'; f.appendChild(i); f.submit(); return; }
        } catch (err) { log('checkout submit failed', err); }
        location.href = ROOT + 'checkout';
      };
      setTimeout(go, 3000);
      waitIdle(2500).then(function () { return state.busy ? null : sync(true); }).then(go, go);
    }, true);
  }

  /* ======================= ŠTART ======================= */
  function init() {
    // hranice sú vo forintoch – pri inej mene (napr. ak sa v Markets zapne EUR) bar ani strážca darčekov nebežia
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (cur && cur !== 'HUF') return;
    if (CFG.CHECKOUT_GUARD) guardCheckout();
    injectCSS();
    renderFromDom();
    decorate(null);

    var form = document.getElementById('AjaxCartForm');
    var cnt = form && form.querySelector('[data-cart-count]');
    // prázdny košík → nie je čo kontrolovať; inak overiť stav (čistí aj darček pridaný cez URL)
    if (!cnt || cnt.textContent.trim() !== '0') sync();

    // téma prepisuje innerHTML #AjaxCartForm po každej zmene (add, qty, remove, refreshCart, quick-buy)
    if (form) {
      new MutationObserver(function () {
        decorate(null);                         // hneď (pred vykreslením) – bez bliknutia +/- pri darčeku
        renderFromDom();
        if (!state.busy) schedule();
        else state.pending = true;
      }).observe(form, { childList: true });
      form.addEventListener('cart-updated', function () { if (!state.busy) schedule(); });
    }
    document.addEventListener('cart-updated', function () { if (!state.busy) schedule(); });

    // akýkoľvek /cart/add|change|update|clear request (aj z appiek alebo konzoly) → overiť košík
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          var path = '';
          try { path = new URL(e.name, location.href).pathname; } catch (x) { return; }
          if (!/\/cart\/(add|change|update|clear)(\.js)?$/.test(path)) return;
          if (state.busy || Date.now() - state.lastOwnAt < 800) return;   // vlastné requesty ignorovať
          schedule(250);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}

    // návrat cez back/forward cache
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(0); });
  }

  window.HeviGiftProgress = { config: HGP_CONFIG, sync: sync, version: '1.0.0' };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
